import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useStore } from 'react-redux';
import { storeCountry, getCountries, updateCountry } from './../../apis/services';
import { Modal } from 'react-bootstrap';
import { Checkbox } from "primereact/checkbox";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from "primereact/inputswitch";
import { setShowDeleteDialog } from '../../redux/reducer';
import DeleteModalContent from '../../commons/DeleteModalContent';

const CollegeCountries = () => {
    const { t } = useTranslation();
    const store = useStore();
    const [countries, setCountries] = useState([]);
    const [showAddCountriesModal, setShowAddCountriesModal] = useState(false);
    const [showEditCountriesModal, setShowEditCountriesModal] = useState({ show: false, item: '' });
    useEffect(() => {
        loadCountries();
    }, []);
    const loadCountries = async () => {
        try {
            const res = await getCountries();
            setCountries(res.data.countries	);
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div>
            <div className="glass-card p-3">
                <div className="d-flex jcsb">
                    <div className='mt-2 mb-2'>
                        <h4>{t('manage_countries')}</h4>
                    </div>
                    <div className='p-2 d-flex'>
                        <Button className='p-btn mx-1'
                            onClick={() => {
                                setShowAddCountriesModal(true);
                            }}
                        > {t('add_country')}</Button>
                    </div>
                </div>
                <Modal
                    show={showAddCountriesModal}
                >
                    <div className='p-4'>
                        <AddCountries
                            submit={() => {
                                setShowAddCountriesModal(false);
                                loadCountries();
                            }}
                            cancel={() => {
                                setShowAddCountriesModal(false);
                            }}
                        />
                    </div>
                </Modal>
                <Modal
                    show={showEditCountriesModal.show}
                >
                    <div className='p-4'>
                        <EditCountries
                            submit={() => {
                                setShowEditCountriesModal({ show: false, item: '' });
                                loadCountries();
                            }}
                            cancel={() => {
                                setShowEditCountriesModal({ show: false, item: '' });
                            }}
                            item={showEditCountriesModal.item}
                        />
                    </div>
                </Modal>
                {

                }
                <DeleteModalContent
                    reload={() => {
                        loadCountries();
                    }}
                />
                <div className="data-table mt-2">
                    <DataTable
                        value={countries}
                        paginator
                        rows={10}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 25, 50]}
                        dataKey="id"
                        selectionMode="checkbox"
                        filterDisplay="menu"
                        emptyMessage={t('data_not_available')}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >
                       
                        <Column
                            field="country_name"
                            header={t('name')}
                            sortable
                        />
                      
                      
                        <Column
                            header={t('status')}
                            sortField='status'
                            sortable
                            body={(row) => {
                                return (
                                    <InputSwitch checked={row.status === 1 ? true : false} />
                                )
                            }}
                        />
                        <Column
                            header={t('actions')}
                            body={(row) => {
                                return (
                                    <div className='d-flex'>
                                        <Button
                                            onClick={(e) => {
                                                setShowEditCountriesModal({ show: true, item: row });
                                            }}
                                            className='icon-btn mx-1' severity='primary' id="edit-btn">
                                            <span className="material-symbols-outlined">
                                                edit
                                            </span>
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                store.dispatch(setShowDeleteDialog({ show: true, url: '/countries/delete/' + row.id }))
                                            }}
                                            className='icon-btn mx-1' severity='danger' id="edit-btn">
                                            <span className="material-symbols-outlined">
                                                delete
                                            </span>
                                        </Button>
                                    </div>
                                )
                            }}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );

}

const AddCountries = (props) => {
    const { t } = useTranslation();
    const [countryTitle, setCountryTitle] = useState();

    const [status, setStatus] = useState(true);
    const handleAddCountries = async () => {
        try {
            let data = {
                countryTitle:countryTitle,
                status:status,

            }
            await storeCountry(data);
            props.submit();
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <form action=""
            onSubmit={(e) => {
                e.preventDefault();
                handleAddCountries();
            }}
        >
            <div className="row">
                <div className="col-12">
                    <div className="d-flex jcsb align-items-center">
                        <h5 className='mt-2 mb-3 opacity'>{t('add_country')}</h5>
                        <Button raised className='icon-btn' severity='secondary' type='button'
                            onClick={() => {
                                props.cancel();
                            }}
                        >
                            <span className="material-symbols-outlined">
                                cancel
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="countryTitle" className='required mb-1' >{t('name')}</label>
                        <input type="text" id="countryTitle" className='form-control' required
                            value={countryTitle}
                            onChange={(e) => { setCountryTitle(e.target.value) }}
                        />
                    </div>
                </div>

                
               
                <div className="col-md-12 mt-2">
                    <div className="d-flex">
                        <div className="flex align-items-center">
                            <Checkbox inputId="status" name="status" checked={status} className=''
                                onChange={() => {
                                    setStatus(!status);
                                }}
                            />
                            <label htmlFor="status" className="ml-2 mx-2">{t('enable_for_use')}</label>
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <Button type='submit' className='p-btn'>{t('save')}</Button>
                </div>
            </div>
        </form>
    );
}
const EditCountries = (props) => {
    const { t } = useTranslation();
    const item = props.item;
    const [countryTitle, setCountryTitle] = useState(item.country_name);

    const [status, setStatus] = useState(item.status === 1 ? true : false);

    const handleEditCountries = async () => {
        try {
            let data = {
                id:item.id,
                countryTitle:countryTitle,
                status:status,

            }
            await updateCountry(data);
            props.submit();
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <form action=""
            onSubmit={(e) => {
                e.preventDefault();
                handleEditCountries();
            }}
        >
            <div className="row">
                <div className="col-12">
                    <div className="d-flex jcsb align-items-center">
                        <h5 className='mt-2 mb-3 opacity'>{t('edit_country')}</h5>
                        <Button raised className='icon-btn' severity='secondary' type='button'
                            onClick={() => {
                                props.cancel();
                            }}
                        >
                            <span className="material-symbols-outlined">
                                cancel
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="countryTitle" className='required mb-1' >{t('name')}</label>
                        <input type="text" id="countryTitle" className='form-control' required
                            value={countryTitle}
                            onChange={(e) => { setCountryTitle(e.target.value) }}
                        />
                    </div>
                </div>
              
             
                <div className="col-md-12 mt-2">
                    <div className="d-flex">
                        <div className="flex align-items-center">
                            <Checkbox inputId="status" name="status" checked={status} className=''
                                onChange={() => {
                                    setStatus(!status);
                                }}
                            />
                            <label htmlFor="status" className="ml-2 mx-2">{t('enable_for_use')}</label>
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <Button type='submit' className='p-btn'>{t('update')}</Button>
                </div>
            </div>
        </form>
    );
}
export default CollegeCountries;